import React from "react";
import { Row, Col, CardBody } from "reactstrap";
import { montoFormat } from "../../helper/amountFormat";

const ConSaldo = ({ datos, deuda }) => {
  const [checked, setChecked] = React.useState(false);
  const client = JSON.parse(localStorage.getItem("client"));
  const handleClick = (e) => {
    e.preventDefault();
  };
  const handleChange = () => {
    setChecked((prev) => !prev);
  };

  const capitalizarPrimeraLetra = (palabra) => {
    return palabra.charAt(0).toUpperCase() + palabra.slice(1).toLowerCase();
  };

  return (
    <CardBody className="custom-card-body card-comision">
      <Row>
        <Col>
          <p className="text-justify">
            Hola {capitalizarPrimeraLetra(client.r_primer_nombre)},
          </p>
          <p className="text-justify">
            En <b>AFP Habitat</b> queremos que siempre estés bien informado sobre tu fondo de jubilación.
            Por eso, te contamos que <b>durante el 2024 no se han registrado aportes obligatorios en
              tu cuenta personal (Cuenta Individual de Capitalización).</b>
          </p>
          <p className="text-justify">
            <b>Tu saldo al 31/03/2025 es el siguiente:</b>
          </p>
          <section className="table-responsive">
            <div className="show-mobile liena-head body-table-item mb-2">
              <div className="body-t custom-cf-mobile">
                <span className="only-mobile">Tipo de Aporte:</span>
                <span className="text-right ml-2">Saldo CIC</span>
              </div>
              <div className="body-t custom-cf-mobile">
                <span className="only-mobile">Aportes Obligatorios:</span>
                <span className="text-right ml-2">
                  S/ {montoFormat(datos.r_obl)}
                </span>
              </div>
              <div className="body-t custom-cf-mobile">
                <span className="only-mobile">
                  Aportes Voluntarios con Fin Previsional:
                </span>
                <span className="text-right ml-2">
                  S/ {montoFormat(datos.r_vcf)}
                </span>
              </div>
              <div className="body-t custom-cf-mobile">
                <span className="only-mobile">
                  Aportes Voluntarios sin Fin Previsional:
                </span>
                <span className="text-right ml-2">
                  S/ {montoFormat(datos.r_vsf)}
                </span>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table show-desktop">
                <thead>
                  <tr>
                    <th className="custom-header-table-noa">Tipo de Aporte</th>
                    <th className="custom-header-table-noa">
                      Aportes Obligatorios
                    </th>
                    <th className="custom-header-table-noa">
                      Aportes Voluntarios con Fin Previsional
                    </th>
                    <th className="custom-header-table-noa">
                      Aportes Voluntarios sin Fin Previsional
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="text-center">
                    <td>Saldo CIC</td>
                    <td>S/ {montoFormat(datos.r_obl)}</td>
                    <td>S/ {montoFormat(datos.r_vcf)}</td>
                    <td>S/ {montoFormat(datos.r_vsf)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
          <p className="text-justify p-table">
            <b>Importante sobre el Seguro de Invalidez, Sobrevivencia y Gastos de Sepelio</b>
          </p>
          <p>
            Para mantener activa la cobertura del seguro, debes haber realizado
            al menos <b>cuatro aportes mensuales en los últimos ocho meses</b> antes de un siniestro.
            <p style={{ marginTop: '0.5rem' }}>
              Este seguro te protege a ti y a tu familia con pensión de invalidez,
              pensión para tus beneficiarios y cobertura de gastos de sepelio.
            </p>
          </p>
          <p className="text-justify" style={{ marginTop: '1.75rem' }}>
            <b>¿Tus boletas de pago muestran descuentos a la AFP?</b>
          </p>
          <p>
            Si eres trabajador(a) dependiente y ves que <b>en tus boletas de pago de 2024 sí te descontaron para la AFP </b>
            , por favor envíanos una copia al correo:{" "}

            <a
              onClick={() => handleClick}
              href="mailto:miagenciavirtual@afphabitat.com.pe"
              rel="noopener noreferrer"
            >
              miagenciavirtual@afphabitat.com.pe
            </a>

            <p style={{ marginTop: '0.5rem' }}>
              Es importante que la boleta tenga <b>firma y sello</b> del representante legal de tu empresa.
              Así podremos gestionar el cobro respectivo con tu empleador.
            </p>
          </p>
          {datos.r_secuencial > 0 && (
            <div>
              <p className="text-justify" style={{ marginTop: '1.75rem' }}>
                <b>A la fecha tus aportes en proceso de cobranza son:</b>
              </p>
              <section className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th className="custom-header-table-noa">
                        Periodo (año/mes)
                      </th>
                      <th className="custom-header-table-noa">
                        Estado de la deuda
                      </th>
                      <th className="custom-header-table-noa">
                        RUC del Empleador
                      </th>
                      <th className="custom-header-table-noa">
                        Razón Social del Empleador
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {deuda.map((item, index) => (
                      <tr key={index} className="text-center">
                        <td>{item.r_periodo}</td>
                        <td>{item.r_estado_deuda}</td>
                        <td>{item.r_ruc_empleador}</td>
                        <td>{item.r_razon_empleador}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </section>
            </div>
          )}
          <p className="text-justify" style={{ marginTop: '1.75rem' }}>
            <b>¿Tienes dudas?</b>
          </p>
          <p>
            ¡Estamos aquí para ayudarte!
            <p style={{ marginTop: '0.5rem' }}>Puedes comunicarte con nosotros:</p>
          </p>
          <ul className="note-list-no-aportante">
            <li className="text-justify">
              <b>WhatsApp</b>: 981-211-004
            </li>
            <li className="text-justify">
              <b>Desde Lima</b>: 01-230-2200
            </li>
            <li className="text-justify">
              <b>Desde provincias</b>: 0-801-14-224
            </li>
          </ul>
          <p className="text-justify" style={{ marginTop: '1.75rem' }}>
            <b>Horario de atención</b>: lunes a viernes: 9 a. m. a 6 p. m. Sábados: 9 a. m. a 1 p. m.
          </p>
        </Col>
      </Row>
    </CardBody>
  );
};

export default ConSaldo;
